import React, { useState, memo, useCallback } from 'react';

const BillRow = memo(({ bill, isExpanded, onToggleExpand, onPay }) => {
  return (
    <>
      <tr onClick={() => onToggleExpand(bill.id)} className='lighten' style={{ cursor: 'pointer' }}>
        <td style={{ width: '30px', textAlign: 'center' }}>{isExpanded ? '▼' : '►'}</td>
        <td>{bill.invoice_number}</td>
        <td>{bill.patient?.name || 'Unknown'}</td>
        <td>{formatCurrency(bill.total_amount)}</td>
        <td>
          {bill.status === 'pending' ? (
            <button
              onClick={(e) => {
                e.stopPropagation(); // Prevent row expand on click
                onPay(bill.patient?.id, bill.category, bill.service_id, bill.patient_queue_id);
              }}
              className="primary text-white bg-yellow-600 hover:bg-yellow-700 px-3 py-1 rounded"
            >
              💳 Pay
            </button>
          ) : (
            bill.status
          )}
        </td>
        <td>{new Date(bill.created_at).toLocaleString()}</td>
      </tr>

      {isExpanded && (
        <tr>
          <td colSpan="6" className='lighten'>
            <strong>Patient Info:</strong><br />
            Name: {bill.patient.name} <br />
            Age: {bill.patient.age} <br />
            Contact: {bill.patient.contact_info}

            <br /><br />
            <strong>Bill Items:</strong>
            <table
              border="1"
              width="100%"
              cellPadding="6"
              style={{ marginTop: '10px', borderCollapse: 'collapse' }}
            >
              <thead>
                <tr>
                  <th>Description</th>
                  <th>Quantity</th>
                  <th>Unit Price</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                {bill.bill_items.map((item) => (
                  <tr key={item.id} className='lighten'>
                    <td>{item.description}</td>
                    <td>{item.quantity}</td>
                    <td>{formatCurrency(item.unit_price)}</td>
                    <td>{formatCurrency(item.total_price)}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            <a
              href={`/api/v1/bills/${bill.id}/print`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ display: 'inline-block', marginTop: '10px', textDecoration: 'none', color: '#38AD3E' }}
            >
              🖨️ Print this bill
            </a>
          </td>
        </tr>
      )}
    </>
  );
});

const BillList = ({ bills, onPay }) => {
  const [expandedBillId, setExpandedBillId] = useState(null);

  const toggleExpand = useCallback(
    (billId) => {
      setExpandedBillId((prevId) => (prevId === billId ? null : billId));
    },
    [setExpandedBillId]
  );

  if (bills.length === 0) {
    return <p>No bills found for this period.</p>;
  }

  return (
    <div>
      <p style={{ fontStyle: 'italic', marginBottom: '10px' }}>
        Click on a bill row to view full details
      </p>
      <table border="1" width="100%" cellPadding="10" style={{ borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th></th>
            <th>Bill ID</th>
            <th>Patient</th>
            <th>Total</th>
            <th>Status</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
          {bills.map((bill) => (
            <BillRow
              key={bill.id}
              bill={bill}
              isExpanded={expandedBillId === bill.id}
              onToggleExpand={toggleExpand}
              onPay={onPay}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

const formatCurrency = (amount) => `Ksh${parseFloat(amount).toFixed(2)}`;

export default BillList;
